import { FileSave } from "src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface";

export interface TaxValidation {
    ci:string;
    name?: string;
    surname?: string;
    ruc?: string,
    typePerson: string,
    socialReason?: string,
}

export interface DataCommerceDto{
    domicilioFiscal :DataSetDto;
    razonSocial: string;
    tipoPersona: string;
    nombre: string;
    apellido: string;
}

export interface UploadScreenTaxInfo {
    fileFrontCI: FileSave | undefined | FileSave[];
    fileBackCI: FileSave | undefined | FileSave[];
    ciValidationRequired: boolean;
}

export interface DataSetDto{
    codigo: string,
    estado: string, // Importante [bloqueado, cancelado, suspendido, abierto]
    mensaje: string,
    contribuyente: {
      categoria: string,
      dv: string,
      estado: string,
      mesCierre: string,
      razonSocial: string, // Importante
      ruc: string,
      rucAnterior: string,
      tipoPersona: string, // Importante
      tipoSociedad: string, // Importante
      valido: string
    }
}

export interface InfoCommerce{ 
    bussinesName: string;
    typePerson: string;
    rucStatus:string;
}

export interface GeoapifyResult{
    query: string,
    latitud: string,
    logintud: string,
}

export class TypePerson {
    public static JURIDICA = "J";
    public static FISICA = "F";
}

export class Constants {
    public static REBA: string = "REBA";
    public static CONDICION_MUNICIPAL: string = "CONDICION_MUNICIPAL";
    public static CONDICION_IIBB: string = "CONDICION_IIBB";
 }

 export const TypePersonOption = [
    { text: "Persona Física", value: "F" },
    { text: "Persona Jurídica", value: "J" },
  ];
